import { type PayloadAction } from '@reduxjs/toolkit';
import type { TVisibility } from 'types/template/template.types';
import type { QuestionEditorsState } from './Question.Editor.Slice';

interface QuestionScopeState {
  visibility: 'global' | 'client' | 'local';
  client_id?: string;
  access_groups_ids?: string[];
  stateModified: boolean;
}

const initialState: QuestionScopeState = {
  visibility: 'client',
  client_id: undefined,
  access_groups_ids: undefined,
  stateModified: false,
};

export const questionScopeReducer = {
  resetScope: (state: QuestionEditorsState, action: PayloadAction<{ questionId: string }>) => {
    const { questionId } = action.payload;
    if (state.byId[questionId]) {
      state.byId[questionId] = {
        ...state.byId[questionId],
        ...initialState,
      };
    }
  },

  updateVisibility: (
    state: QuestionEditorsState,
    action: PayloadAction<{
      questionId: string;
      visibility: TVisibility;
    }>,
  ) => {
    const { questionId, visibility } = action.payload;

    if (!state.byId[questionId]) return;

    state.byId[questionId].visibility = visibility;
    if (visibility === 'global') {
      state.byId[questionId].client_id = undefined;
    }
    state.byId[questionId].stateModified = true;
  },

  updateClientId: (
    state: QuestionEditorsState,
    action: PayloadAction<{
      questionId: string;
      clientId: string | undefined;
    }>,
  ) => {
    const { questionId, clientId } = action.payload;

    if (!state.byId[questionId]) return;

    state.byId[questionId].client_id = clientId;
    state.byId[questionId].stateModified = true;
  },

  updateAccessGroupIds: (
    state: QuestionEditorsState,
    action: PayloadAction<{
      questionId: string;
      accessGroupIds: string[] | undefined;
    }>,
  ) => {
    const { questionId, accessGroupIds } = action.payload;

    if (!state.byId[questionId]) return;

    state.byId[questionId].access_groups_ids = accessGroupIds;
    state.byId[questionId].stateModified = true;
  },
};
